
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { AccountingPlanModel } from './Entities.Accounting.AccountingPlan';
import { LedgerHeaderModel } from './Entities.Accounting.LedgerHeader';
import { LedgerPostType } from 'enums/LedgerPostType';
import { BcDocumentLineType } from 'enums/BcDocumentLineType';
import { BillingDocumentLineModel } from './Accounting.IntegrationAbstractions.BillingDocumentLine';
import { Model, ModelProperty } from 'models/Model';


export class LedgerPostModel extends Model<LedgerPostModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'ledgerHeaderId', type: 'string' },
		{ name: 'accountingPlanId', type: 'string' },
		{ name: 'lineNumber', type: 'number' },
		{ name: 'plannedDate', type: 'Date' },
		{ name: 'value', type: 'number' },
		{ name: 'creditedPostedDocumentNo', type: 'string' },
		{ name: 'creditedLineNumber', type: 'number' },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'lineTypeNumber', type: 'string' },
		{ name: 'description', type: 'string' },
		{ name: 'productDimension', type: 'string' },
		{ name: 'salesTypeDimension', type: 'string' },
		{ name: 'departmentDimension', type: 'string' },
		{ name: 'companyDimension', type: 'string' },
		{ name: 'accountingPlan', type: 'AccountingPlanModel', isHidden: true, isObject: true, new: () => { return new AccountingPlanModel }, properties: () => { return AccountingPlanModel.classProperties } },
		{ name: 'ledgerHeader', type: 'LedgerHeaderModel', isHidden: true, isObject: true, new: () => { return new LedgerHeaderModel }, properties: () => { return LedgerHeaderModel.classProperties } },
		{ name: 'type', type: 'LedgerPostType' },
		{ name: 'lineType', type: 'BcDocumentLineType' },
		{ name: 'subtractValue', type: 'boolean' },
		{ name: 'signedValue', type: 'number' },
		{ name: 'isInvoice', type: 'boolean' },
		{ name: 'isCreditMemo', type: 'boolean' },
		{ name: 'isRegistered', type: 'boolean' },
		{ name: 'isFutureInvoice', type: 'boolean' },
		{ name: 'isEditable', type: 'boolean' },
		{ name: 'isClick', type: 'boolean' },
		{ name: 'documentLine', type: 'BillingDocumentLineModel', isHidden: true, isObject: true, new: () => { return new BillingDocumentLineModel }, properties: () => { return BillingDocumentLineModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public ledgerHeaderId?: string;
	public accountingPlanId?: string;
	public lineNumber?: number;
	public plannedDate?: Date;
	public value: number;
	public creditedPostedDocumentNo: string;
	public creditedLineNumber?: number;
	public productPlanId?: string;
	public lineTypeNumber: string;
	public description: string;
	public productDimension: string;
	public salesTypeDimension: string;
	public departmentDimension: string;
	public companyDimension: string;
	public accountingPlan?: AccountingPlanModel;
	public ledgerHeader?: LedgerHeaderModel;
	public type: LedgerPostType;
	public lineType?: BcDocumentLineType;
	public subtractValue: boolean;
	public signedValue: number;
	public isInvoice: boolean;
	public isCreditMemo: boolean;
	public isRegistered: boolean;
	public isFutureInvoice: boolean;
	public isEditable: boolean;
	public isClick: boolean;
	public documentLine?: BillingDocumentLineModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.ledgerHeaderId = undefined;
		this.accountingPlanId = undefined;
		this.lineNumber = undefined;
		this.plannedDate = undefined;
		this.value = 0;
		this.creditedPostedDocumentNo = '';
		this.creditedLineNumber = undefined;
		this.productPlanId = undefined;
		this.lineTypeNumber = '';
		this.description = '';
		this.productDimension = '';
		this.salesTypeDimension = '';
		this.departmentDimension = '';
		this.companyDimension = '';
		this.accountingPlan = undefined;
		this.ledgerHeader = undefined;
		this.type = 0;
		this.lineType = undefined;
		this.subtractValue = false;
		this.signedValue = 0;
		this.isInvoice = false;
		this.isCreditMemo = false;
		this.isRegistered = false;
		this.isFutureInvoice = false;
		this.isEditable = false;
		this.isClick = false;
		this.documentLine = undefined;
		
	}
	getProperties(){
		return LedgerPostModel.classProperties;
	}
}

